"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "Wie schützt SecureNetics meine digitale Infrastruktur?",
  answer: "Wir setzen auf einen mehrschichtigen Sicherheitsansatz, der modernste Firewalls, Intrusion Detection Systeme und kontinuierliches Monitoring kombiniert. Unsere Experten analysieren Ihre spezifischen Schwachstellen und implementieren maßgeschneiderte Protokolle zum Schutz vor Cyber-Angriffen."
}, {
  question: "Bieten Sie auch Beratungsleistungen für KMU an?",
  answer: "Ja, wir skalieren unsere Lösungen für Unternehmen jeder Größe. Von der ersten Risikoanalyse bis zur Implementierung komplexer Sicherheitsarchitekturen unterstützen wir mittelständische Betriebe dabei, ein Sicherheitsniveau auf Enterprise-Standard zu erreichen."
}, {
  question: "Was passiert im Falle eines Sicherheitsvorfalls?",
  answer: "Unser Incident Response Team ist sofort einsatzbereit. Wir verfügen über vordefinierte Notfallpläne zur Eindämmung von Bedrohungen, zur Datenwiederherstellung und zur forensischen Analyse, um zukünftige Angriffe effektiv zu verhindern."
}, {
  question: "Sind Ihre Lösungen konform mit der DSGVO?",
  answer: "Absolut. Datenschutz und Compliance sind Kernbestandteile unserer Strategie. Wir stellen sicher, dass alle technischen und organisatorischen Maßnahmen den aktuellen gesetzlichen Anforderungen entsprechen und Ihre Datenverarbeitung rechtssicher ist."
}, {
  question: "Wie kann ich eine erste Sicherheitsanalyse anfordern?",
  answer: "Sie können uns direkt über unser Kontaktformular erreichen oder uns unter +49 (0) 800-SECURE-NET anrufen. Unser Team vereinbart zeitnah einen Termin für ein Erstgespräch, um Ihren individuellen Bedarf zu ermitteln."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222948" id="häufige-fragen-zur-sicherheit" className="w-full py-16 md:py-24 lg:py-32 bg-background text-foreground">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 max-w-4xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-foreground mb-4 tracking-tight">
            Häufige Fragen zur Sicherheit
          </h2>
          <p className="text-lg text-muted-foreground font-default max-w-2xl mx-auto tracking-wide">
            Erfahren Sie mehr über unsere technologische Exzellenz und wie wir Ihre Systeme vertrauenswürdig machen.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border border-border rounded-xl bg-card/50 backdrop-blur-md overflow-hidden transition-all duration-300 data-[state=open]:border-primary/40 data-[state=open]:shadow-[0_0_15px_rgba(0,212,255,0.1)]">
              <AccordionTrigger className="text-[18px] font-bold font-default hover:no-underline hover:bg-accent/10 px-6 py-5 transition-colors text-foreground data-[state=open]:text-primary">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-[16px] font-normal font-sans text-muted-foreground px-6 pb-6 pt-2 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}